import PortfolioCreateLayout from './portfolioCreateLayout.js';

export default PortfolioCreateLayout;
